import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { CardBody, Card } from "reactstrap";
// components
import ALoader from "views/pages/manage/common/a-loader";
import ReceiptFiltersDrawer from "../components/ReceiptFiltersDrawer";
import StudentSearchBar from "../../components/StudentSearchBar";
import TopHeaderBar from "../../components/TopHeaderBar";
import DepositedReceiptsList from "../components/DepositedReceiptsList";

// hooks
import { useFetchList } from "../../hooks/useFetchList";
import { getDepositedReceiptListApi } from "../api/cashDeposits.service";
import { useFetchDropdown } from "../hooks/useDropdown";
import { updateRequest } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
// helpers
import "../../styles/cashManagement.scss";
import { useBuTypeNameByBuId } from "../../hooks/useFetchBuType";
const SEARCH_STYLE = { fontSize: "12px" }; // Defined outside to prevent re-creation
const ViewDepositedReceiptsPage = () => {
  // 1. URL & Navigation
  const { id: businessAreaId, depositId, cashierOffice } = useParams();

  // 2. Data Fetching
  const dropdownValues = useFetchDropdown();

  // 3. List Management
  const [searchInput, setSearchInput] = useState("");
  const [searchBy, setSearchBy] = useState("psid");

  const {
    rows,
    loading: isListLoading,
    pagination,
    onPageChange,
    onPageSizeChange,
    filters,
    onFilterApply,
  } = useFetchList(getDepositedReceiptListApi, {
    initialPageSize: 100, // Consider lowering this
    businessAreaId,
    depositId,
    cashierOffice,
    initialFilters: {},
  });

  // 4. Selection Logic
  const [selectedIds, setSelectedIds] = useState(new Set());

  const updatedPagination = useMemo(
    () => ({
      ...pagination,
      page: pagination.page + 1, // Adjusting for 1-based UI
    }),
    [pagination]
  );

  // Logic: Reset selection when page changes to prevent "Ghost selections"
  useEffect(() => {
    setSelectedIds(new Set());
  }, [pagination.page]);

  // 6. Filter Handlers
  const applyFilterHandler = useCallback(
    (newFilter) => {
      onFilterApply(updateRequest(newFilter));
    },
    [onFilterApply]
  );

  const applyPrimaryFilter = useCallback(() => {
    onFilterApply({ [searchBy]: searchInput });
  }, [onFilterApply, searchBy, searchInput]);

  const removeFilterFormHandler = useCallback(() => {
    onFilterApply({});
  }, [onFilterApply]);

  const { buTypeName, loading } = useBuTypeNameByBuId(businessAreaId)

  // 7. Render Helpers
  const headerData = useMemo(
    () => ({
      Type: buTypeName,
    }),
    [buTypeName]
  );


  return (
    <>
      <div className="remove-container-top-space">
        <TopHeaderBar title="View Receipts" headerData={headerData} />

        <div className="cm-container">
          {(isListLoading || loading) && <ALoader position="fixed" />}

          <Card>
            <CardBody>
              <div className="d-flex justify-content-between mb-3">
                <div className="heading-3 color-black semi-bold">
                  {pagination.total} Receipts
                </div>

                <div className="d-flex gap-md">
                  <div>
                    <StudentSearchBar
                      searchValue={searchInput}
                      onChange={setSearchInput}
                      onKeyDown={applyPrimaryFilter}
                      onSearchClick={applyPrimaryFilter}
                      dropdownValue={searchBy}
                      onDropdownChange={setSearchBy}
                      dropdownStyles={SEARCH_STYLE}
                    />
                  </div>

                  <ReceiptFiltersDrawer
                    applyFilterHandler={applyFilterHandler}
                    appliedForm={filters}
                    dropdownValues={dropdownValues}
                    onRemoveFilterHandler={removeFilterFormHandler}
                  />
                </div>
              </div>

              <DepositedReceiptsList
                rows={rows}
                loading={isListLoading}
                pagination={updatedPagination}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                selectedIds={selectedIds}
                onSelectionChange={setSelectedIds}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ViewDepositedReceiptsPage;
